import { AfterViewInit, Directive, ElementRef, Input } from "@angular/core";
import { ResizeManagerService } from "../_provider/resize-manager.service";
import { Platform } from "@ionic/angular";

export interface HoverTitleData{
    text?: string
    background?: string,
    backdropBlur?: boolean
    position?: "left" | "right" | "top" | "bottom" | "bottom-left" | "top-right"
}

@Directive({
    selector: "[hoverTitle]"
})
export class HoverTitleDirective{
    @Input() set hoverTitle(data: HoverTitleData){
        if(!data?.text || this.platform.is("capacitor")) return

        const element = this.elementRef.nativeElement
        element.style.position = "relative"
        
        const hoverElement = document.createElement("div")
        hoverElement.classList.add("hover-title")
        hoverElement.innerHTML = data.text
        hoverElement.style.background = data?.background ? data.background : "var(--background2)"

        if(data.position == "left") hoverElement.classList.add("hover-title-left")
        else if(data.position == "right") hoverElement.classList.add("hover-title-right")
        else if(data.position == "bottom") hoverElement.classList.add("hover-title-bottom")
        else if(data.position == "bottom-left") hoverElement.classList.add("hover-title-bottom-left")
        else if(data.position == "top-right") hoverElement.classList.add("hover-title-top-right")
        else hoverElement.classList.add("hover-title-top")

        if(data.backdropBlur) hoverElement.classList.add("hover-title-backdrop-blur")
        
        element.appendChild(hoverElement)
        element.onmouseenter = () => hoverElement.classList.add("hover-title-active")
        element.onmouseleave = () => hoverElement.classList.remove("hover-title-active")
        
    }
    constructor(
        private elementRef: ElementRef,
        private platform: Platform
    ) {}

}  